import { httpClient } from '../http-client';
import { IpsData } from './ips.types';

export const getIPS = async (clientId: string | number, flow: string): Promise<IpsData> => {
	const { data } = await httpClient.get<IpsData>(`/clients/${clientId}/flows/${flow}/ips`);

	return data;
};

export const updateIPS = async (
	clientId: string | number,
	flow: string,
	payload: FormData
): Promise<{ pdfId: string }> => {
	const { data } = await httpClient.post<{ pdfId: string }>(
		`/clients/${clientId}/flows/${flow}/ips`,
		payload,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);

	return data;
};

export const getGeneratedIpsPDF = async (
	clientId: string | number,
	id?: string
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<string> => {
	const { data } = await httpClient.get<string>(`/clients/${clientId}/ips-pdf-download/${id}`, {
		responseType: 'blob',
	});

	return data;
};
